import React, { useEffect, useState } from "react";

const LOGO = "/assets/protos-logo.png";

export default function Navbar({ onNotify }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const links = [
    { label: "Product", id: "what" },
    { label: "Why", id: "why" },
    { label: "Origin", id: "origin" },
    { label: "Protos 100", id: "beta" },
    { label: "Apply", id: "notify" },
  ];

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <header
        data-testid="navbar"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled || open
            ? "bg-black/75 backdrop-blur-xl border-b border-white/5"
            : "bg-transparent"
        }`}
      >
        <div className="container-x flex items-center justify-between px-5 md:px-6 lg:px-10 py-4 md:py-5">
          <a
            href="#top"
            data-testid="nav-logo"
            data-magnet
            className="flex items-center"
            aria-label="Protos home"
            onClick={() => setOpen(false)}
          >
            <img
              src={LOGO}
              alt="PROTOS"
              className="h-7 md:h-9 w-auto"
              style={{ filter: "drop-shadow(0 0 18px rgba(31,179,255,0.35))" }}
              onError={(e) => {
                e.currentTarget.style.display = "none";
                e.currentTarget.nextElementSibling.style.display = "inline-flex";
              }}
            />
            <span
              className="font-display text-xl md:text-2xl tracking-wider"
              style={{ display: "none", letterSpacing: "0.04em" }}
            >
              <span className="text-white">PRO</span>
              <span style={{ color: "var(--blue-bright)" }}>TOS</span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-7">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-${l.id}`}
                data-magnet
                onClick={() => scrollTo(l.id)}
                className="font-mono text-xs uppercase tracking-[0.22em] text-white/60 hover:text-white transition-colors"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              data-testid="nav-notify-btn"
              data-magnet
              onClick={onNotify}
              className="btn-primary !py-2.5 !px-4 md:!py-3 md:!px-5 !text-[0.7rem] md:!text-[0.72rem]"
            >
              <span>Apply</span>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 12h14M13 5l7 7-7 7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            {/* mobile burger */}
            <button
              data-testid="nav-menu-toggle"
              aria-label="Toggle menu"
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className="md:hidden w-10 h-10 inline-flex flex-col items-center justify-center gap-1.5 border border-white/15 rounded-full"
            >
              <span
                className={`block h-px w-4 bg-white transition-transform duration-300 ${
                  open ? "translate-y-[3px] rotate-45" : ""
                }`}
              />
              <span
                className={`block h-px w-4 bg-white transition-transform duration-300 ${
                  open ? "-translate-y-[3px] -rotate-45" : ""
                }`}
              />
            </button>
          </div>
        </div>
      </header>

      {/* mobile overlay */}
      <div
        data-testid="mobile-menu"
        className={`md:hidden fixed inset-0 z-40 transition-all duration-500 ${
          open ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div className="absolute inset-0 bg-black/90 backdrop-blur-2xl" />
        <nav className="relative h-full flex flex-col justify-center px-8 gap-2">
          {links.map((l, i) => (
            <button
              key={l.id}
              data-testid={`mnav-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-left font-display uppercase text-5xl text-white py-3 border-b border-white/8 transition-all duration-500"
              style={{
                transform: open ? "translateX(0)" : "translateX(-30px)",
                opacity: open ? 1 : 0,
                transitionDelay: open ? `${i * 70 + 100}ms` : "0ms",
              }}
            >
              {l.label}
            </button>
          ))}
          <div
            className="mt-10 transition-all duration-500"
            style={{
              transform: open ? "translateX(0)" : "translateX(-30px)",
              opacity: open ? 1 : 0,
              transitionDelay: open ? `${links.length * 70 + 100}ms` : "0ms",
            }}
          >
            <button
              data-testid="mnav-apply"
              onClick={() => {
                setOpen(false);
                onNotify();
              }}
              className="btn-primary"
            >
              <span>Apply to Protos 100</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 12h14M13 5l7 7-7 7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </nav>
      </div>
    </>
  );
}
